import React from "react";

/**
 * テキストの中のリンクを処理するHOOK
 */
export function useTextWithLinks() {
  /**
   * テキスト中のURLをリンクする
   * @param text テキスト
   * @returns テキストとリンク
   */
  const processTextWithLinks = React.useCallback(
    (text: string): React.ReactNode[] => {
      if (!text) return [text];

      const parts: React.ReactNode[] = [];

      // httpかhttpsで始まるURL
      const urlStartRegex = /https?:\/\//g;
      let lastIndex = 0;
      let match;

      while ((match = urlStartRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
          parts.push(text.substring(lastIndex, match.index));
        }

        const urlStartIndex = match.index;
        let urlEndIndex = text.length;

        // URLの末尾
        const possibleEndChars = [
          " ",
          "　",
          ")",
          "]",
          ">",
          '"',
          "'",
          "\n",
          "\t",
          "\r",
          "、",
          "。",
        ];

        const urlPart = text.substring(urlStartIndex);
        const hasQueryParams = urlPart.includes("?");
        if (hasQueryParams) {
          // クエリがある場合
          for (let i = urlStartIndex + 8; i < text.length; i++) {
            if (possibleEndChars.includes(text[i])) {
              urlEndIndex = i;
              break;
            }
          }
        } else {
          // クエリがない場合
          const japaneseStart =
            /[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF]/;

          for (let i = urlStartIndex + 8; i < text.length; i++) {
            const char = text[i];
            // 区切り文字
            if (possibleEndChars.includes(char)) {
              urlEndIndex = i;
              break;
            }
            // 日本語
            if (japaneseStart.test(char)) {
              urlEndIndex = i;
              break;
            }
          }
        }

        // 最後のURL
        const url = text.substring(urlStartIndex, urlEndIndex);
        // 末尾で符号を削除
        const cleanUrl = url.replace(/[.,;:!?]+$/, "");

        // リンクする
        parts.push(
          <a
            key={`link-${urlStartIndex}`}
            href={cleanUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline inline break-all hover:text-blue-800"
            style={{ color: "var(--bot-bubble-link)" }}
          >
            {cleanUrl}
          </a>
        );

        // 次のURL
        lastIndex = urlEndIndex;
      }

      // 残りのテキスト
      if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex));
      }

      return parts;
    },
    []
  );

  return { processTextWithLinks };
}
